import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({ selector: '[sl-selectable]' })
export class SlSelectableDirective {
  constructor(private el: ElementRef) { }


  @Input('sl-selectable')
  targetSelector?: string;

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    if (event.key !== 'Enter' && event.key !== ' ') {
      return;
    }

    event.preventDefault();

    const target = this.GetTarget();
    target?.focus()
    if (!target) return;
    if ('showPicker' in (target as any)) {
      try {
        (target as any)?.showPicker();
      } catch {
        // Browser does not permit programmatic opening.
      }
    }
  }
  private GetTarget(): HTMLElement | null {
    const host = this.el.nativeElement;

    if (!this.targetSelector) {
      return host;
    }

    return host.querySelector(this.targetSelector);
  }
}
